// 平台圖示：同一個家族（PS4／PS5、Xbox One／Series、Switch／Switch 2）共用字形。
import type { PlatformKey } from '@dayone/core/dictionaries';
import { BRAND_PATHS } from './brand-paths.ts';

export type Glyph = 'windows' | 'playstation' | 'xbox' | 'switch' | 'apple' | 'linux' | 'ios' | 'android';

export const PLATFORM_GLYPH: Record<PlatformKey, Glyph> = {
  pc: 'windows',
  ps5: 'playstation',
  ps4: 'playstation',
  xsx: 'xbox',
  xone: 'xbox',
  switch: 'switch',
  switch2: 'switch',
  mac: 'apple',
  linux: 'linux',
  ios: 'ios',
  android: 'android',
};

function GlyphSvg({ glyph }: { glyph: Glyph }) {
  switch (glyph) {
    case 'windows':
      return <path d="M3 5.5 10.5 4.4v7.1H3zM11.5 4.3 21 3v8.5h-9.5zM3 12.5h7.5v7.1L3 18.5zm8.5 0H21V21l-9.5-1.3z" />;
    case 'xbox':
      return (
        <>
          <circle cx="12" cy="12" r="9.2" fill="none" stroke="currentColor" strokeWidth="2.2" />
          <path d="M8 7.6 16 16.4M16 7.6 8 16.4" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        </>
      );
    case 'switch':
      return (
        <>
          <rect x="3" y="3" width="8" height="18" rx="4" fill="none" stroke="currentColor" strokeWidth="2" />
          <rect x="13" y="3" width="8" height="18" rx="4" />
          <circle cx="7" cy="8" r="1.6" />
        </>
      );
    default:
      return <path d={BRAND_PATHS[glyph]} />;
  }
}

/** 單一平台圖示；名稱由外層提供（清單的說明浮窗或文字標籤），這裡只負責圖形 */
export function PlatformIcon({ platform, className = 'pi' }: { platform: PlatformKey; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      <GlyphSvg glyph={PLATFORM_GLYPH[platform]} />
    </svg>
  );
}

/** 同家族只顯示一次（例如 PS4＋PS5 只出現一個 PlayStation 圖示），保留原本順序 */
export function uniqueGlyphs(platforms: readonly PlatformKey[]): PlatformKey[] {
  const seen = new Set<Glyph>();
  return platforms.filter((p) => {
    const g = PLATFORM_GLYPH[p];
    if (seen.has(g)) return false;
    seen.add(g);
    return true;
  });
}
